import { useCallback, useEffect, useRef, useState } from "react";
import { Button } from "reactstrap";
import classNames from "classnames";

import image from "../../assets/ic-logo-qr.svg?react";
import { ReactComponent as IconQrLogo } from "../../assets/ic-logo-qr.svg";
import { ReactComponent as IconDownload } from "../../assets/ic_download.svg";

import styles from "./index.module.scss";

const QR = ({ username, shareLink }) => {
  const [generatedQR, setGeneratedQR] = useState(null);
  const canvasRef = useRef();

  const size = 155;
  const qrCodeSize = 300;

  const makeCanvas = useCallback(async (ctx, qrCode, scale) => {
    ctx.scale(scale, scale);

    ctx.font = "600 20px 'Micro Premium SemiBold'";
    ctx.textAlign = "center";
    ctx.direction = "ltr";

    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, qrCodeSize, qrCodeSize);

    ctx.fillStyle = "black";

    const raw = await qrCode.getRawData("png");

    const img = new Image(qrCodeSize, qrCodeSize);
    img.src = URL.createObjectURL(raw);
    img.onload = () => ctx.drawImage(img, 5, 5, 145, 145);

    setGeneratedQR(qrCode);
  }, []);

  const downloadImage = useCallback(
    async (type) => {
      if (generatedQR) {
        // 175x175px => 290x290px with 58px margin
        generatedQR.update({
          width: 290,
          height: 290,
          margin: 10,
        });

        await generatedQR.download({ name: username, extension: type });
      }
    },
    [generatedQR, username],
  );

  const downloadPng = () => downloadImage("png");
  const downloadJpeg = () => downloadImage("jpeg");
  const downloadSvg = () => downloadImage("svg");

  useEffect(() => {
    const ctx = canvasRef.current.getContext("2d");
    const scale = window.devicePixelRatio;

    const makeQrCode = async () => {
      const QRCodeStyling = (await import("qr-code-styling")).default;
      const qrCode = new QRCodeStyling({
        image,
        width: 175,
        height: 175,
        dotsOptions: {
          color: "black",
          type: "square",
        },
        data: shareLink,
        imageOptions: {
          margin: 6,
        },
      });

      void makeCanvas(ctx, qrCode, scale);
    };

    void makeQrCode();
  }, []);

  return (
    <div className={classNames("d-flex align-items-center")}>
      <div className={classNames("position-relative", styles.qrContainer)}>
        <canvas
          ref={canvasRef}
          width={size * window.devicePixelRatio}
          height={size * window.devicePixelRatio}
          style={{ width: size, height: size, borderRadius: 16 }}
        />
        <IconQrLogo width={28} height={29} className={styles.qrLogo} />
      </div>

      <div
        className={classNames(
          "d-flex flex-column justify-content-between h-100",
          styles.downloadBtnContainer,
        )}
      >
        <Button onClick={downloadPng} className={styles.button}>
          <IconDownload className="text-primary me-1" width="15" height="15" />
          <span className="text-primary text-body-2 text-medium">PNG</span>
        </Button>
        <Button onClick={downloadJpeg} className={styles.button}>
          <IconDownload className="text-primary me-1" width="15" height="15" />
          <span className="text-primary text-body-2 text-medium">JPG</span>
        </Button>
        <Button onClick={downloadSvg} className={styles.button}>
          <IconDownload className="text-primary me-1" width="15" height="15" />
          <span className="text-primary text-body-2 text-medium">SVG</span>
        </Button>
      </div>
    </div>
  );
};

export default QR;
